import TableViewCol from './TableViewCol';

export default TableViewCol;
